import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

/**
 * Scrolls to the top on every route change (or to the `#hash` target when
 * there is one). Browser back/forward keeps the native scroll position.
 */
export function useScrollToTop() {
  const { pathname, hash } = useLocation()
  const navigationType = useNavigationType()

  useEffect(() => {
    if (navigationType === 'POP') return

    if (hash) {
      // Lazy pages may not have rendered the target yet — retry for a few frames.
      let attempts = 0
      const tryScroll = () => {
        const target = document.getElementById(hash.slice(1))
        if (target) {
          target.scrollIntoView({ block: 'start' })
        } else if (attempts++ < 20) {
          requestAnimationFrame(tryScroll)
        }
      }
      tryScroll()
      return
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname, hash, navigationType])
}
